module.exports = __webpack_public_path__ + "media/images/glyphs/close-438b8dfff7217f127a3b5204dda01fe2.svg";